module.exports = __webpack_public_path__ + "img/two_top_img.f50182a7.png";